import React from 'react';
import { IconType } from 'react-icons';

import { Container } from './styles';

type OptionType = {
  isCheck: boolean;
  Icon: IconType;
  onClick: () => void;
};

const Option: React.FC<OptionType> = ({ Icon, isCheck, onClick }) => {
  return (
    <Container isCheck={isCheck} onClick={onClick}>
      <Icon />
    </Container>
  );
};

export default Option;
